import React, { useState, useEffect } from "react";
import "./css/board.css";
import NobleSidebar from "./NobleSidebar";

const BoardD = () => {
  const [directorData, setDirectorData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDirectorData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/boarddirector?fields=*.*.*`,
          { cache: "no-store" }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }

        const data = await response.json();

        if (data?.data?.length > 0) {
          const director = data.data[0];
          const fullImageUrl = director.profilephoto?.data?.full_url
            ? director.profilephoto.data.full_url.replace("http://", "https://")
            : "";

          setDirectorData({
            name: director.directorname,
            message: director.directormessage,
            imageUrl: fullImageUrl,
          });
        }
      } catch (error) {
        console.error("Failed to fetch director data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDirectorData();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className="container-fluid d-flex latest_card_box_ad pt-0">
        <div className="ourschoolboardeft px-3 text-left">
          <h4 className="kalurr mt-3" style={{ color: "black", fontWeight: "bold" }}>
            Board Of Director
          </h4>

          <div className="princd">
            <div className="photos">
              {loading ? (
                <p>Loading image...</p>
              ) : (
                <img
                  src={directorData?.imageUrl || "/default-director.jpg"}
                  alt={directorData?.name || "Director"}
                />
              )}
              <div className="phname">
                <b>Director</b> - {directorData?.name || "Loading..."}
              </div>
            </div>

            <div className="director_mess">
              <h5>
                <b>Director Message -</b>
              </h5>
              <p>
                {directorData?.message ||
                  "Dear Parent & Students, Welcome to The Katara Hills International family!"}
              </p>
            </div>
          </div>

          <p>
            <b>
              The Board of Directors is the main governing body of The Katara Hills School
              
            </b>
          </p>

        </div>

        <div className="ourschoolright p-4">
          <NobleSidebar />
        </div>
      </div>
    </div>
  );
};

export default BoardD;
